import { Card, Form, Input, Row, } from "antd";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Page from "../../common/components/Page";
import CleanButton from "../../common/components/CleanButton";
import useEFile from "./useEFile";
import { RootState } from "../../store";
import EFileSummaryCard from "./EFileSummaryCard";
import { useNavigate } from "react-router";

const EFileQuestions = () => {
  const { submitAnswers, eFileForm } = useEFile();
  const { eFileQuestions } = useSelector((state: RootState) => state.eFileApi);
  const history = useNavigate()
  useEffect(() => {
    if (!eFileQuestions) {
      history("/EFile");
    }
  });

  return (
    <Page>
      <Page.Title icon="check" title="E-File" />
      <Page.Content>
        {eFileQuestions?.List?.length > 0 ? (<Form form={eFileForm} onFinish={submitAnswers}>
          <EFileSummaryCard isCollapse></EFileSummaryCard>
          <br/>
          {eFileQuestions?.List.map((question, index) =>
            <div key={question?.QuestionId}>
              <Row>
                <Form.Item key={question.QuestionId} hidden name={[question?.QuestionId.toString(), "QuestionText"]} initialValue={question?.QuestionText} />
                <h2>{question?.QuestionText}</h2>
              </Row>
              <Row gutter={16}>
                <Form.Item key={question.QuestionId} name={[question?.QuestionId.toString(), "Answer"]} initialValue={question?.Answer} rules={[{ required: true, message: 'This field is required' }]} style={{ width: "90%" }} >
                  <Input.TextArea style={{ height: "calc(1.6em*4)" }} maxLength={4000} showCount>
                  </Input.TextArea>
                </Form.Item>
              </Row>
            </div>
          )}
          <Form.Item>
            <CleanButton icon="check" htmlType="submit" onClick={() => submitAnswers()}>
              Review
            </CleanButton>
          </Form.Item>
        </Form>
        ) : (<div>
          <Card>
            <div style={{ lineHeight: "28px" }}>
              <b>There are no additional questions required for this E-File Option. Please continue to review.</b>
            </div>
            <CleanButton icon="check" htmlType="submit" onClick={() => submitAnswers()}>
              Review
            </CleanButton>
          </Card>

        </div>)}
      </Page.Content>
    </Page>
  );
};

export default EFileQuestions;
